import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatOption } from '@angular/material/autocomplete';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { QuotesRoutingModule } from '@sbd-doug-frontend/app/modules/quotes/quotes-routing.module';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'sbd-account-portal-frontend-drawer-content-wrapper',
  standalone: true,
  imports: [CommonModule, MatMenuTrigger, MatIconButton, MatIcon, MatMenu, MatMenuItem, MatFormField, MatLabel, MatOption, MatSelect, QuotesRoutingModule, ReactiveFormsModule],
  templateUrl: './drawer-content-wrapper.component.html',
})
export class DrawerContentWrapperComponent {
  @Input() title: string;
  @Output() selectedShippingMethodID: EventEmitter<string> = new EventEmitter<string>();

  onShippingMethodChange($event: MatSelectChange) {
    const value = $event.value;
    this.selectedShippingMethodID.emit(value);
  }
}
